<template>
  <aha-modal
    title="Import AhaSlides from spreadsheet"
    classes="mb-6"
    @hide="hide()"
  >
    <div class="pb-4">
      MS Excel, Libre Office, Google Sheets and Numbers
      <div>
        1.
        <a
          class="text-primary-90 text-decoration"
          href="https://s3.amazonaws.com/public.ahaslide.com/template-sheet/ahaslides-quiz-template.xlsx"
          download
          @click="handleDownloadTemplate"
        >Download our template</a>
      </div>
      <div>2. Fill it out and save as .xlsx</div>
    </div>

    <div class="tab-content">
      <label
        for="upload-file"
        class="text-center"
      >
        <div v-if="importStatus == 1">
          <div
            v-if="importError"
            class="px-3 text-red-100 error-text"
            v-html="importError"
          />

          <div>
            <div class="py-2">
              <p class="pb-1">3. Drag and drop here (Max file size:1MB)</p>
              <p>or</p>
            </div>
          </div>
        </div>

        <div
          v-if="importStatus == 2 || importStatus == 3"
          class="text-center"
        >
          <p v-if="importStatus == 2" class="text-lg font-bold">Uploading...</p>
          <p v-if="importStatus == 3" class="text-lg font-bold">Import Done!</p>

          <div class="pt-2">
            Large presentations may take several minutes to finish. do not close this window
            <br>The imported slides will be added to the end of your presentation.
          </div>
        </div>

        <b-form-file
          id="upload-file"
          v-model="file"
          :state="Boolean(file)"
          choose-label="Attachment2"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          drop-placeholder="drop image"
          :file-name-formatter="uploadFile"
          @mouseup.stop
        />
      </label>
      <aha-button v-if="importStatus === 1" @click="handleBrowseFile">
        Browse File...
        <b-form-file
          id="upload-file"
          v-model="file"
          :state="Boolean(file)"
          choose-label="Attachment2"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          drop-placeholder="drop image"
          :file-name-formatter="uploadFile"
          @mouseup.stop
        />
      </aha-button>
    </div>
  </aha-modal>
</template>

<script>
import { mapState } from 'vuex'
import Config from '@/config'
import Socket from '@/socket'
import Utils from '@/util'
import EventBus from '@/eventBus'
import gaCategories from '@/constant/gaCategories'

export default {
  data() {
    return {
      file: null,
      importStatus: 1,
      importError: null,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
  },
  mounted() {
  },
  methods: {
    async uploadFile(files) {
      if (!files || !files.length) return
      const file = files[0]
      this.importError = ''
      if (file && file.size > 1024000) {
        this.importError =
          '<div>Maximum file size is 1 MB. Maximum slide amount is 100 slides. <br /> Please try again with a smaller file.</div>'
        Utils.gaTrackEvent(
          'Presentation',
          'Import .xlsx',
          'Exceed 1MB',
        )
        return
      }

      const ext = file.name.split('.').pop()
      if (ext.indexOf('xlsx') === -1) {
        this.importError =
          'Could not upload this file (only support file xlsx).'
        Utils.gaTrackEvent(
          'Presentation',
          'Import xlsx',
          'Invalid file type',
        )
        return
      }

      this.importStatus = 2
      const formData = new FormData()
      formData.append('file', file)
      formData.append('socketId', Socket.getSocketId())
      formData.append('fileSize', file.size)
      formData.append('fileName', file.name)
      formData.append('id', this.presentation.id)
      const headers = new Headers()
      headers.append('Content-Type', 'application/x-www-form-urlencoded')
      const url = Config.api.uploadXlsx
      const resp = await this.$http.post(url, formData)
      this.importStatus = 2
      try {
        const respSlides = await this.$http.post(Config.api.importFileSheet, {
          presentationId: this.presentation.id,
          file: resp.body.file.key,
        })
        if (respSlides.body.length) {
          this.$store.state.isNewPresentation = false
          if (!this.presentation.slides[this.presentation.slides.length - 1].id) {
            this.presentation.slides.splice(this.presentation.slides.length - 1, 1)
          }
          this.presentation.slides = this.presentation.slides.concat(respSlides.body)
          setTimeout(() => {
            EventBus.$emit('makeSlideActive', respSlides.body[0])
          }, 500)
        }
        this.importStatus = 3
        this.hide()
        Utils.showToastSuccess('Import Done!')
        Utils.gaTrackEvent(
          gaCategories.PRESENTATION_EDITOR,
          'Create new slide',
          'Import Spreadsheet',
        )
      } catch {
        this.importStatus = 1
        this.importError = 'Please recheck your file or contact support'
      }
    },
    hide() {
      this.$store.state.openModalImportSheet = false
    },
    handleDownloadTemplate() {
      Utils.gaTrackEvent(
        gaCategories.PRESENTATION_EDITOR,
        'Download our template',
        'AhaSlides Quiz Template',
      )
    },
    handleBrowseFile() {
      Utils.gaTrackEvent(
        gaCategories.PRESENTATION_EDITOR,
        'Import Spreadsheet > Browse file',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.tab-content {
  @apply border-2 border-dashed border-primary-90 px-4;
  @apply bg-primary-60 rounded py-8;
  @apply relative text-center;
}
.custom-file {
  @apply absolute inset-0 overflow-hidden opacity-0;
  & ::v-deep .custom-file-input {
    @apply w-full  h-full cursor-pointer;
  }
}

.text-decoration {
  text-decoration: underline;
}

</style>
